import {BigId, ColonistOneTimePurchaseType} from '@colonist/types'

export interface GiftPurchaseData {
    senderUserId?: BigId
    giftPurchaseType: GiftPurchaseType
    oneTimePurchaseType: ColonistOneTimePurchaseType
    receiverUsername: string | undefined
    duration: number
    giftMessage: string
    applied?: boolean
}

export enum GiftPurchaseType {
    GiftURL,
    GiftToUser,
}
